<div class="device-register">
  <div class="device-register__title">Register with the device code</div>
  <div class="device-register__code" *ngIf="code">{{ code }}</div>
  <div class="device-register__expiration" *ngIf="expireAt">Expires {{ expireAt | date: 'medium' }}</div>
  <div class="device-register__message" *ngIf="message">{{ message }}</div>
</div>
